let btnright = [
  {
    source: { id: "engadget", name: "Engadget" },
    author: "Mariella Moon",
    title: "Apple's 512GB MacBook Air M2 is $220 off right now",
    description:
      "You can get the latest MacBook Air on sale right now — even better, the discounted variant is the one with the bigger storage capacity. The silver 2022 MacBook Air with 512GB of internal storage and Apple's M2 processor is currently listed for $1,279 on Amazo…",
    url: "https://www.engadget.com/apple-512-gb-macbook-air-m2-deal-amazon-111848575.html",
    urlToImage:
      "https://s.yimg.com/os/creatr-uploaded-images/2022-12/2b410ad0-875b-11ed-951f-09dde045094d",
    publishedAt: "2022-12-29T11:18:48Z",
    content:
      "You can get the latest MacBook Air on sale right now even better, the discounted variant is the one with the bigger storage capacity. The silver 2022 MacBook Air with 512GB of internal storage and Ap… [+1916 chars]",
  },
  {
    source: { id: "engadget", name: "Engadget" },
    author: "Mat Smith",
    title: "The Morning After: The winners and losers in tech this year",
    description:
      "As we approach the end of the year, it’s time for Engadget to wrap up the successes and failures in tech from the last twelve months. While it might be easier point out the messes made by the likes of crypto, Google’s Stadia cloud gaming platform and, ugh, Tw…",
    url: "https://www.engadget.com/the-morning-after-the-winners-and-losers-in-tech-this-year-121548540.html",
    urlToImage:
      "https://s.yimg.com/os/creatr-uploaded-images/2022-02/6b26bbf0-8765-11ec-bffe-9c53b58697a5",
    publishedAt: "2022-12-29T12:15:48Z",
    content:
      "As we approach the end of the year, its time for Engadget to wrap up the successes and failures in tech from the last twelve months. While it might be easier point out the messes made by the likes of… [+3878 chars]",
  },
  {
    source: { id: "wired", name: "Wired" },
    author: "WIRED Staff",
    title: "Is It 2023 Yet?",
    description:
      "This week, we look back at 2022’s biggest consumer tech stories. Then, we offer our predictions for what the next 12 months will bring.",
    url: "https://www.wired.com/story/gadget-lab-podcast-579/",
    urlToImage:
      "https://media.wired.com/photos/63a4b9e3460886d10ec90365/191:100/w_1280,c_limit/Gear-metaverse-1434700854.jpg",
    publishedAt: "2022-12-29T13:00:00Z",
    content:
      "Michael Calore: In one word?\r\nLauren Goode: I'll give you a phrase.\r\nMichael Calore: Elon Musk.\r\nLauren Goode: Oh, really? It's like a proper noun.\r\nMichael Calore: Yeah.\r\nLauren Goode: It's like an … [+3578 chars]",
  },
  {
    source: { id: "ars-technica", name: "Ars Technica" },
    author: "Jonathan M. Gitlin",
    title: "Here are the 10 best new cars, trucks, and SUVs we drove in 2022",
    description: "Eight EVs made the top 10 this year.",
    url: "https://arstechnica.com/cars/2022/12/here-are-the-10-best-new-cars-trucks-and-suvs-we-drove-in-2022/",
    urlToImage:
      "https://cdn.arstechnica.net/wp-content/uploads/2022/12/ars-top10-cars-2022-760x380.jpg",
    publishedAt: "2022-12-29T11:55:34Z",
    content:
      "0 with 0 posters participating\r\nAh, the annual end-of-year roundup, when it's time to sit down and think about all the vehicles we tested in 2022. Comparing this year to years past, it's notable how … [+10625 chars]",
  },
  {
    source: { id: "reuters", name: "Reuters" },
    author: null,
    title: "Pele brought glamour and goals to the Big Apple - Reuters",
    description:
      "Of all the headlines Pele made on the football field, few of them came close to the remarkable announcement he made off it in 1975 - when he came out of retirement to sign for a little-known U.S. club called the New York Cosmos.",
    url: "https://www.reuters.com/lifestyle/sports/pele-brought-glamour-goals-big-apple-2022-12-29/",
    urlToImage:
      "https://www.reuters.com/resizer/k1dqrRXuAgYjwDfkLiRXEVw0INo=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/26OA7QURHZJXPMGSONNLHRTGQM.jpg",
    publishedAt: "2022-12-29T19:20:00Z",
    content:
      "Dec 29 (Reuters) - Of all the headlines Pele made on the football field, few of them came close to the remarkable announcement he made off it in 1975 - when he came out of retirement to sign for a li… [+2997 chars]",
  },
  {
    source: { id: "reuters", name: "Reuters" },
    author: null,
    title:
      "India's 5G smartphone shipments to cross 4G shipments in 2023 ... - Reuters",
    description:
      "India's 5G smartphone shipments will exceed that of 4G shipments by the end of next year, driven by the mass adoption of the high-speed network and the rise in sale of handsets in the lower-price bands, market research firm Counterpoint said on Thursday.",
    url: "https://www.reuters.com/technology/indias-5g-smartphone-shipments-cross-4g-shipments-2023-counterpoint-2022-12-29/",
    urlToImage:
      "https://www.reuters.com/resizer/NUvMsDGTGgjNrBrbtu4jnwQ5SwI=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/TA5BUY22PBKJ3MNWLN36AVPPKU.jpg",
    publishedAt: "2022-12-29T08:52:00Z",
    content:
      "BENGALURU, Dec 29 (Reuters) - India's 5G smartphone shipments will exceed that of 4G shipments by the end of next year, driven by the mass adoption of the high-speed network and the rise in sale of h… [+1699 chars]",
  },
  {
    source: { id: "reuters", name: "Reuters" },
    author: null,
    title:
      "Egypt leads 2022 gains, Saudi marks first annual loss in 7 years - Reuters",
    description:
      "The Saudi Arabian stock market ended lower on Wednesday, marking its first annual loss in seven years, while the Egyptian bourse was the Middle East's best performer in 2022.",
    url: "https://www.reuters.com/world/middle-east/egypt-leads-2022-gains-saudi-marks-first-annual-loss-7-years-2022-12-29/",
    urlToImage:
      "https://www.reuters.com/resizer/9Oeratg6XGQ9I1RPdTcIz38jT1Q=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/NFAXBGSDPRLHZPT7PVY6KYAHGM.jpg",
    publishedAt: "2022-12-29T16:28:00Z",
    content:
      "Dec 29 (Reuters) - The Saudi Arabian stock market ended lower on Wednesday, marking its first annual loss in seven years, while the Egyptian bourse was the Middle East's best performer in 2022.\r\nSaud… [+2530 chars]",
  },
  {
    source: { id: "reuters", name: "Reuters" },
    author: null,
    title: "Futures rise ahead of jobless claims data, Tesla jumps - Reuters",
    description:
      'U.S. stock index futures gained on Thursday ahead of labor market data that will give clues on future interest rate hikes, while Tesla extended gains after top boss Elon Musk told staff to ignore the "stock market craziness".',
    url: "https://www.reuters.com/markets/us/futures-rise-ahead-jobless-claims-data-tesla-jumps-2022-12-29/",
    urlToImage:
      "https://www.reuters.com/resizer/ye73W5gI6ktM4D3fBrYDO04ofTI=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/KZ2NLTK52BKD5DCCR3ZUMJHTO4.jpg",
    publishedAt: "2022-12-29T12:19:00Z",
    content:
      "Dec 29 (Reuters) - U.S. stock index futures gained on Thursday ahead of labor market data that will give clues on future interest rate hikes, while Tesla extended gains after top boss Elon Musk told … [+2350 chars]",
  },
  {
    source: { id: null, name: "Android Central" },
    author: "techkritiko@gmail.com (Jay Bonggolto)",
    title:
      "Wearable devices could also see a uniform charging standard in India",
    description:
      "India is considering a common charging solution for wearable devices in addition to smartphones, tablets, and laptops.",
    url: "https://www.androidcentral.com/wearables/wearable-devices-common-charging-standard-india",
    urlToImage:
      "https://cdn.mos.cms.futurecdn.net/YPG6jEH9hGAs4LMQTim2M5-1200-80.jpg",
    publishedAt: "2022-12-29T06:29:51Z",
    content:
      "<ul><li>India is reportedly mulling two types of charging standards for electronic devices.</li><li>A single charging solution is being considered for wearable devices, along with existing plans to a… [+2335 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author:
      "Presented by Max Rushden with Barry Glendenning, Jonathan Wilson and Robyn Cowen. Produced by Joel Grove and our executive producer is Max Sanderson.",
    title: "Haaland leads the way for Manchester City – Football Weekly Extra",
    description:
      "Max Rushden is joined by Barry Glendenning, Jonathan Wilson and Robyn Cowen after more midweek Premier League actionRate, review, share on Apple Podcasts, Soundcloud, Audioboom, Mixcloud, Acast and Stitcher, and join the conversation on Facebook, Twitter and …",
    url: "https://www.theguardian.com/football/audio/2022/dec/29/erling-haaland-leads-the-way-for-manchester-city-football-weekly-podcast",
    urlToImage:
      "https://i.guim.co.uk/img/media/f227b1ed3d0f1a5bf3b2634ef2e1123fbea9090f/0_288_4438_2662/master/4438.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=91bb163114ec1ada56ed60555341e2cb",
    publishedAt: "2022-12-29T13:01:24Z",
    content:
      "Rate, review, share on Apple Podcasts, Soundcloud, Audioboom, Mixcloud, Acast and Stitcher, and join the conversation on Facebook, Twitter and email.\r\nToday: incredibly, despite the break for the Wor… [+443 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author: "Samuel Gibbs Consumer technology editor",
    title:
      "Guardian tech reviews in 2022: better to repair and longer-lasting devices",
    description:
      "More devices contain recycled materials and are supported for longer, but there is much more to doWith a year full of pressures on our wallets, comfort and climate, technology took a back seat in 2022. But change for the better is slowly happening as big tech…",
    url: "https://www.theguardian.com/technology/2022/dec/29/guardian-tech-reviews-2022-repair-recycled-materials",
    urlToImage:
      "https://i.guim.co.uk/img/media/3d153cfdc64fc6bf618b7f84ce806881435460e7/66_230_5390_3234/master/5390.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=176e6edbb9549d549a8fc17b1b420365",
    publishedAt: "2022-12-29T09:00:15Z",
    content:
      "With a year full of pressures on our wallets, comfort and climate, technology took a back seat in 2022. But change for the better is slowly happening as big tech firms wake up to the demands of consu… [+6379 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author: "Anna Berrill",
    title: "Delicious dishes with marsala | Kitchen aide",
    description:
      "Use this Sicilian fortified wine in cocktails, boozy desserts, for adding to soups … or just as cook’s special treatGot a culinary dilemma? Email feast@theguardian.comI made Felicity Cloake’s tiramisu, which was delicious, but I still have a nearly full bottl…",
    url: "https://www.theguardian.com/food/2022/dec/29/delicious-dishes-to-make-with-marsala",
    urlToImage:
      "https://i.guim.co.uk/img/media/92cd6ce3383e836c693bd21e8945b5457d365c9f/611_0_3102_1861/master/3102.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=e455b318e9d6bd29c10619d40fccdce0",
    publishedAt: "2022-12-29T12:00:19Z",
    content:
      "I made Felicity Cloakes tiramisu, which was delicious, but I still have a nearly full bottle of marsala. What else can I make with it?Viv, CardiffNot all marsala is made equal: you have secco (dry), … [+3007 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author: "Simon Hattenstone",
    title:
      "‘I’ve hit 60 – I’m officially an old fart and I’m going to embrace it’: the thing I’ll do differently in 2023",
    description:
      "People have started to offer me their seats on the bus. But I don’t mind. Far from denying my age, I am going to flaunt itI’m 60 on 29 December. Wooohooo! For the past five years, I’ve already been thinking of myself as 60, and now I’m ready to truly embrace …",
    url: "https://www.theguardian.com/lifeandstyle/2022/dec/29/60-old-fart-embrace-it-thing-ill-do-differently",
    urlToImage:
      "https://i.guim.co.uk/img/media/f1642ca0d8d0d31c1a000457a58544ee7bab4edb/0_0_8192_4915/master/8192.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=5271a98b1d10f4bbd5f3a83cae31fb70",
    publishedAt: "2022-12-29T10:00:16Z",
    content:
      "Im 60 on 29 December. Wooohooo! For the past five years, Ive already been thinking of myself as 60, and now Im ready to truly embrace it. Presumably, on 30 December Ill start thinking of myself as 70… [+2920 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author: "Greg Wood",
    title: "State Man eases to Matheson Hurdle success at Leopardstown",
    description:
      "<ul><li>State Man beat Vauban by four-and-a-quarter lengths</li><li>Sharjah completed one-two-three for Willie Mullins’ stable</li></ul>State Man, last season’s County Handicap Hurdle winner at Cheltenham, continued his progress towards a possible meeting wit…",
    url: "https://www.theguardian.com/sport/2022/dec/29/state-man-eases-to-matheson-hurdle-success-at-leopardstown",
    urlToImage:
      "https://i.guim.co.uk/img/media/b2d386129eea1506f65f630b56dfe954bb3c6bf2/0_63_4500_2700/master/4500.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=4644f36ae8de57bf5aa3b17dbf49bec9",
    publishedAt: "2022-12-29T18:17:20Z",
    content:
      "State Man, last seasons County Handicap Hurdle winner at Cheltenham, continued his progress towards a possible meeting with the unbeaten Constitution Hill at the Festival in March with a convincing s… [+4199 chars]",
  },
  {
    source: { id: null, name: "The Guardian" },
    author: "Gaby Hinsliff",
    title:
      "Ignore the purists – listening to a book instead of reading it isn’t skiving or cheating | Gaby Hinsliff",
    description:
      "From audiobooks to podcasts and voice notes, there’s a steady generational shift in the way we understand the worldInsomniacs do it in the middle of the night. Dog owners do it while trudging round the park. Some people do it in the gym, but lately I’ve taken…",
    url: "https://www.theguardian.com/commentisfree/2022/dec/29/listening-reading-audiobooks-podcasts-generational-shift",
    urlToImage:
      "https://i.guim.co.uk/img/media/24abab3e2ae1ef39165ed0f7dd593d1ada4559f0/0_0_2560_1536/master/2560.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctb3BpbmlvbnMucG5n&enable=upscale&s=4d291011acb75a845a378507d12eb41d",
    publishedAt: "2022-12-29T06:00:12Z",
    content:
      "Insomniacs do it in the middle of the night. Dog owners do it while trudging round the park. Some people do it in the gym, but lately Ive taken to doing it alone in the car, on long journeys north th… [+6315 chars]",
  },
  {
    source: { id: null, name: "MacRumors" },
    author: "Juli Clover",
    title:
      "Apple Working on 11.1-Inch and 13-Inch OLED iPad Pro Models for 2024",
    description:
      "Apple is developing 11.1-inch and 13-inch OLED iPad Pro models that will come out in the first quarter of 2024, display analyst Ross Young today confirmed to MacRumors.\n\n\n\n\n\nYoung has previously mentioned new OLED ‌iPad Pro‌ models planned for 2024, but this …",
    url: "https://www.macrumors.com/2022/12/29/oled-ipads-2024/",
    urlToImage:
      "https://images.macrumors.com/t/rsVF5zSOxqabm37AgyNQWmw0p8U=/2500x/article-new/2022/11/12.9-inch-ipad-pro-cyber.jpg",
    publishedAt: "2022-12-29T17:37:29Z",
    content:
      "Apple is developing 11.1-inch and 13-inch OLED iPad Pro models that will come out in the first quarter of 2024, display analyst Ross Young today confirmed to MacRumors.\r\nYoung has previously mentione… [+1539 chars]",
  },
  {
    source: { id: null, name: "MacRumors" },
    author: "Sami Fathi",
    title:
      "Apple Reportedly Requested Samsung to Use More Advanced Production Method for iPhone 14 Pro Displays",
    description:
      "To create the iPhone 14 Pro's display with the pill-shaped cutout at the top, Apple requested that Samsung, the company's leading display supplier, use a more advanced production method that would protect the surrounding display from possible damage and loss …",
    url: "https://www.macrumors.com/2022/12/29/apple-samsung-iphone-14-pro-production/",
    urlToImage:
      "https://images.macrumors.com/t/RaBq1kQm57HqYgjTIXI3iF3ucKU=/2500x/article-new/2022/09/iPhone-14-Pros-in-Hand-Black-Background-Feature.jpg",
    publishedAt: "2022-12-29T07:28:57Z",
    content:
      "To create the iPhone 14 Pro's display with the pill-shaped cutout at the top, Apple requested that Samsung, the company's leading display supplier, use a more advanced production method that would pr… [+2574 chars]",
  },
  {
    source: { id: null, name: "MacRumors" },
    author: "Sami Fathi",
    title:
      "Apple Mini-LED Display Supplier Says Demand Shrinking As Rumors Suggest Transition to OLED in Coming Years",
    description:
      "One of Apple's leading mini-LED suppliers says demand for displays in consumer products is shrinking while demand for mini-LED in other use cases is rising as Apple eyes a transition to move its iPad and MacBook line to OLED displays in the coming years. \n\n\n\n…",
    url: "https://www.macrumors.com/2022/12/29/apple-mini-led-suppliers-oled/",
    urlToImage:
      "https://images.macrumors.com/t/hIXj0LHsCAepM-B_dJ5z96rVSgM=/2500x/article-new/2021/11/Oled-iPads-and-MackBook-Pro-Notch.jpg",
    publishedAt: "2022-12-29T08:06:20Z",
    content:
      "One of Apple's leading mini-LED suppliers says demand for displays in consumer products is shrinking while demand for mini-LED in other use cases is rising as Apple eyes a transition to move its iPad… [+1085 chars]",
  },
  {
    source: { id: null, name: "NPR" },
    author: "Giulia Heyward",
    title:
      "Unclaimed luggage piles up at airports following Southwest cancellations",
    description:
      "After Southwest Airlines canceled thousands of flights over the week, travelers are scrambling to reunite with their luggage.",
    url: "https://www.npr.org/2022/12/29/1145846556/unclaimed-luggage-flight-cancellations-winter-storm-southwest",
    urlToImage:
      "https://media.npr.org/assets/img/2022/12/28/gettyimages-1452939496_wide-63f5488a692431d9713cdcab3acc006dded51959-s1400-c100.jpg",
    publishedAt: "2022-12-29T10:00:53Z",
    content:
      "Unclaimed luggage at the William P. Hobby Airport on Thursday in Houston, Texas.\r\nBrandon Bell/Getty Images\r\nA winter storm led Southwest Airlines to cancel thousands of flights over the holiday seas… [+6141 chars]",
  },
  {
    source: { id: null, name: "Slashdot.org" },
    author: "msmash",
    title: "Europe Taps Tech's Power-Hungry Data Centers To Heat Homes",
    description:
      "With an energy crisis hitting Europe, governments are exploring ways to recycle electricity used on social-media scrolling, conference calls and video streaming to help heat homes and offices. From a report: Electricity-hungry data centers are seeing huge gro…",
    url: "https://tech.slashdot.org/story/22/12/29/1738243/europe-taps-techs-power-hungry-data-centers-to-heat-homes",
    urlToImage: "https://a.fsdn.com/sd/topics/technology_64.png",
    publishedAt: "2022-12-29T19:00:00Z",
    content:
      "Electricity-hungry data centers are seeing huge growth in usage, leading to pressure from European officials to funnel the excess heat generated by their computer chips into municipal heating network… [+1377 chars]",
  },
];
export default btnright;
